module.exports = __webpack_public_path__ + "static/media/November_2026_5.0730e318.webp";